import { ISetDateRangeAction, ActionTypes, ISetOverrideAction } from './CalendarFilter.action-types';

export const setDateRange = (data?: Date[], date?: Date, stateUpdateStatus?: boolean): ISetDateRangeAction => ({
    type: ActionTypes.SET_DATE_RANGE,
    data,
    date,
    stateUpdateStatus
});

export const setOverride = (data: boolean): ISetOverrideAction => ({
    type: ActionTypes.SET_OVERRIDE,
    data
});
